(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[569],{

/***/ 4386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unreleased",
      function () {
        return __webpack_require__(2752);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageGliph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


function ImageGliph(param) {
    var src = param.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "glyph-image-container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            layout: "raw",
            width: "200",
            height: "200",
            src: "/assets/animated-glyphs/".concat(src, ".gif")
        })
    });
}


/***/ }),

/***/ 2142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var ImageWithTransition = function(param) {
    var src = param.src, layout = param.layout, sizes = param.sizes, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, classes = param.classes, objectFit = param.objectFit, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var onLoadingComplete = function() {
        return setIsLoading(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        className: "".concat(classes, " transition-all duration-500 ").concat(isLoading ? "opacity-0" : "opacity-100"),
        src: src,
        layout: layout,
        onLoadingComplete: onLoadingComplete,
        objectFit: objectFit,
        priority: priority,
        quality: quality,
        loading: loading,
        alt: alt,
        sizes: sizes
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWithTransition);


/***/ }),

/***/ 2752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Unreleased; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_MetaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8992);
/* harmony import */ var components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4721);
/* harmony import */ var components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7603);
/* harmony import */ var components_Elements_ImageWithTransition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2142);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var strapi_api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1014);
/* harmony import */ var plyr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1443);
/* harmony import */ var plyr__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(plyr__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5935);
/* harmony import */ var components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4318);











var __N_SSG = true;
function Unreleased(param) {
    var meta_info = param.meta_info, content = param.content;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var options = {
            title: "Example Title",
            controls: [
                "play-large",
                "progress"
            ],
            autoplay: false,
            muted: true,
            loop: {
                active: true
            }
        };
        var players = Array.from(document.querySelectorAll(".video-player")).map(function(p) {
            return new (plyr__WEBPACK_IMPORTED_MODULE_7___default())(p, options);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_MetaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: (meta_info === null || meta_info === void 0 ? void 0 : meta_info.meta_title) ? meta_info.meta_title : "UNRELEASED",
                description: (meta_info === null || meta_info === void 0 ? void 0 : meta_info.meta_description) ? meta_info.meta_description : "ZANAD | An Independent Animation Production Studio",
                image: (meta_info === null || meta_info === void 0 ? void 0 : meta_info.og_image) ? strapi_api__WEBPACK_IMPORTED_MODULE_10__/* ["default"].getNextImage */ .Z.getNextImage(meta_info.og_image, "large") : "/public/og-image.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                style: {
                    backgroundColor: "#FFFFFF"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "offscreen-title",
                        children: "Careers"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__/* .ContainerWithOffset */ .jZ, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mt-8 mb-6 uppercase fluid-type",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex flex-row justify-start",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "optical-align letter-i",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 3.5,
                                                    children: "The "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 1,
                                                    children: "archived"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 2.5,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        src: "MARGIN_PENCIL"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "inline-block 414:inline",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 6,
                                                        children: "bits"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex flex-row justify-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "text-right",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 2,
                                                    children: "that "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 5,
                                                    children: "never "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 1.5,
                                                    children: "saw "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 4.5,
                                                    children: "the"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 2.5,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        src: "MARGIN_BLOOD"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    num: 4.5,
                                                    children: "light."
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "unreleased-wrapper",
                                children: content.Row && content.Row.map(function(row, key) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                        children: [
                                            row.__component === "unreleased.image-left" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "grid grid-cols-12 gap-3 uppercase",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "col-span-9",
                                                        children: [
                                                            row.video_url === null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "image-container !bg-transparent",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageWithTransition__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                    src: "https://zanad.tv" + row.media.data.attributes.url,
                                                                    alt: "",
                                                                    title: "",
                                                                    layout: "fill",
                                                                    objectFit: "cover"
                                                                })
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "unreleased_video",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: row.autoplay === true ? "video-player autoplay w-100" : "video-player w-100",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                                        loading: "lazy",
                                                                        id: "video",
                                                                        src: row.video_url,
                                                                        allowFullScreen: true,
                                                                        allowtransparency: "true",
                                                                        allow: "autoplay"
                                                                    })
                                                                })
                                                            }),
                                                            row.media_caption !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "grid grid-cols-8 640:grid-cols-9",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "col-span-1 640:col-span-3"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "col-span-6 my-2 text-center 640:col-span-3 640:my-6 media_caption",
                                                                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(row.media_caption)
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "my-4 640:my-20"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex col-span-3",
                                                        children: row.gif.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "self-end yellowguy-wrapper",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "grid grid-cols-6",
                                                                children: [
                                                                    key === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "hidden col-span-1 640:block"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "col-span-6 text-center 640:col-span-4 paragraph_style",
                                                                                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(content.intro_text)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "flex col-span-6",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "self-end image-container !bg-transparent",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageWithTransition__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                                src: "https://zanad.tv" + row.gif.data.attributes.url,
                                                                                alt: "",
                                                                                title: "",
                                                                                layout: "fill",
                                                                                objectFit: "cover"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            row.__component === "unreleased.image-right" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "grid grid-cols-12 gap-3 uppercase",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex col-span-3",
                                                        children: row.gif.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "self-end yellowguy-wrapper",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "grid grid-cols-6",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "flex col-span-6",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "self-end image-container !bg-transparent",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageWithTransition__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                            src: "https://zanad.tv" + row.gif.data.attributes.url,
                                                                            alt: "",
                                                                            title: "",
                                                                            layout: "fill",
                                                                            objectFit: "cover"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "col-span-9",
                                                        children: [
                                                            row.video_url === null ? row.media.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "image-container !bg-transparent",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageWithTransition__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                    src: "https://zanad.tv" + row.media.data.attributes.url,
                                                                    alt: "",
                                                                    title: "",
                                                                    layout: "fill",
                                                                    objectFit: "cover"
                                                                })
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "unreleased_video",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: row.autoplay === true ? "video-player autoplay w-100" : "video-player w-100",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                                        loading: "lazy",
                                                                        id: "video",
                                                                        src: row.video_url,
                                                                        allowFullScreen: true,
                                                                        allowtransparency: "true",
                                                                        allow: "autoplay"
                                                                    })
                                                                })
                                                            }),
                                                            row.media_caption !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "grid grid-cols-8 640:grid-cols-9",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "col-span-1 640:col-span-3"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "col-span-6 my-2 text-center 640:col-span-3 640:my-6 media_caption",
                                                                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(row.media_caption)
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "my-4 640:my-20"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            row.__component === "unreleased.full-width" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "grid grid-cols-12 gap-3 uppercase",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "col-span-12",
                                                    children: [
                                                        row.video_url === null ? row.media.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "image-container !bg-transparent",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageWithTransition__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                src: "https://zanad.tv" + row.media.data.attributes.url,
                                                                alt: "",
                                                                title: "",
                                                                layout: "fill",
                                                                objectFit: "cover"
                                                            })
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "unreleased_video",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: row.autoplay === true ? "video-player autoplay w-100" : "video-player w-100",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                                    loading: "lazy",
                                                                    id: "video",
                                                                    src: row.video_url,
                                                                    allowFullScreen: true,
                                                                    allowtransparency: "true",
                                                                    allow: "autoplay"
                                                                })
                                                            })
                                                        }),
                                                        row.media_caption !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "grid grid-cols-12",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "col-span-3"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "col-span-6 my-2 text-center 640:my-6 media_caption",
                                                                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(row.media_caption)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "my-4 640:my-20"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,608,443,774,888,179], function() { return __webpack_exec__(4386); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);